/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const JSG = require('../../JSG');
const Node = require('./Node');
const ItemAttributes = require('../attr/ItemAttributes');
const StringExpression = require('../expr/StringExpression');

/**
 * @class CaptionNode
 * @extends Node
 * @constructor
 */
module.exports = class CaptionNode extends Node {
	constructor() {
		super();

		this.getFormat().setFillColor(JSG.theme.caption);
		this.getFormat().setLineColor(JSG.theme.frame);
		this.getFormat().setLineCorner(75);
		this.getTextFormat().setFontColor(JSG.theme.captiontext);
		this.getItemAttributes().setPortMode(ItemAttributes.PortMode.NONE);
		this.getItemAttributes().setContainer(false);
		this.getItemAttributes().setSnapTo(false);
		this.getItemAttributes().setSelectionMode(ItemAttributes.SelectionMode.NONE);
	}

	newInstance() {
		return new CaptionNode();
	}

	_copy(copiednodes, deep, ids) {
		const copy = super._copy(copiednodes, deep, ids);

		return copy;
	}

	getItemType() {
		return 'captionnode';
	}

	_assignName() {
		// this.setName('Caption' + id);
	}

	isAddLabelAllowed() {
		return false;
	}

	getTooltip() {
		if (this.getType().getValue() === 'inboxcaption') {
			let message = `${JSG.getLocalizedString('NoMessages')} ${this.properties.messageCount}`;
			if (this.connections) {
				message += `<p style="font-weight: bold">${JSG.getLocalizedString('Connections')}</p>`
				this.connections.forEach(connection => {
					message += `${connection.name} - ${JSG.getLocalizedString(connection.isConnected ? 'Connected' : 'NotConnected')}<br/>`;
				});
			}
			return new StringExpression(message);
		}
		return super.getTooltip();
	}

	read(reader, object) {
		super.read(reader, object);

		// overwrite old settings
		this.getFormat().setFillColor(JSG.theme.caption);
		this.getFormat().setLineColor(JSG.theme.frame);
		this.getTextFormat().setFontColor(JSG.theme.captiontext);
	}

	setIcon(name) {
		this._icon = name;
	}

	setIconLink(link) {
		this._iconLink = link;
	}

	getIconLink() {
		return this._iconLink;
	}
};
